export default __webpack_public_path__ + "static/media/graignes7.a1adf901.jpg";